import { useState } from "react";
import { useAxios } from "../../../utils/useAxios";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";

/**
 * @typedef {Object} ClassroomAssignment
 * @property {number} id - The ID of the classroom
 * @property {boolean} is_assign - The assignment status
 * @property {string} [due_date] - The due date
 */

/**
 * Custom hook to handle assigning classrooms to a lesson
 */
export const useAssignClassrooms = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { axiosInstance } = useAxios();

  /**
   * Assigns classrooms to a lesson
   * @param {Object} params - The parameters
   * @param {number} params.lessonId - The lesson ID
   * @param {ClassroomAssignment[]} params.assignmentData - The assignment data
   * @returns {Promise<Object|null>}
   */
  const assignClassrooms = async ({ lessonId, assignmentData }) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance.post(
        `${TENANT_DOMAIN}/lessons/${lessonId}/assign-classrooms`,
        {
          classrooms: assignmentData,
        },
      );

      return response.data;
    } catch (err) {
      if (err.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    assignClassrooms,
    loading,
    error,
    setError
  };
};
